export const name = 'rnAuthInterceptor';
export default function rnAuthInterceptor($log, $q, $injector, $rootScope, rnAUTH_EVENTS) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // misbehaving APIs or APIs that we don't want to attempt to revalidate to user session
  let BLACKLIST = [
    '/api/aaa/v1/users/validate',         // returns 401 instead of 404 as it should
    '/api/aaa/v1/users/login',            // returns 401 instead of 404 as it should
    '/api/aaa/v1/users/logout',
    '/api/supportapp-service/v1/askexpert/questioncharacteristics/retrieveAll',  // TODO: Help app should not be making authenticated calls with anonymous user
    '/api/PrintbeatService/PerformanceTracking/WeeklyReport/many', // TODO: this was blocking reseller login
    '/api/notification-service/v1/', // system notifications currently return 401 for an unauthenticated user but shouldn't
  ];

  // APIs that we do want to pop up a sign-in dialog if it returns a 401.
  let WHITELIST = [
  ];

  let service = {
    responseError: responseError,
  };

  return service;

  /////////////////

  function responseError(response) {
    // This interceptor only cares about security status errors - 401 (unauthenticated)
    if (response.status === 401) {
      // If it is in the white list then we really do want to pop a sign-in dialog now.
      if (checkAPI(WHITELIST, response)) {
        $log.debug('401 returned from Whitelisted API - broadcast a notAuthenticated event now');
        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, response);
      }
      // If it's not in the blacklist or accepted through config then revalidate the session with AAA
      else if (!allowBypass(response)) {
        $log.debug(`Validating user with AAA - got a 401 from ${response.config.url}`);
        //rnAuthService.validate();
        let rnAuthService = $injector.get('rnAuthService');
        rnAuthService.authenticate(true, true, false);
      }
    }
    return $q.reject(response);
  }


  /**
   * @returns { match<Boolean>} [Indicates this APIs was found in the list]
   */
  function checkAPI(list, response) {
    return _.includes(list, getPathFromURL(response.config.url));
  }


  /**
   * @returns {boolean} true if request can bypass authentication, false otherwise
   */
  function allowBypass(response) {
    if (checkAPI(BLACKLIST, response)) {
      return true;
    }

    return _.get(response.config, 'rhino.allow401', false);
  }


  /**
   * getPathFromURL - return the path portion from a full URL
   */
  function getPathFromURL(url) {
    // Use the browsers native URL creation/parsing to get the path - significantly faster then writing our own js code
    let parser = document.createElement('a');
    parser.href = url;
    let path =  parser.pathname;
    if(path.charAt(0) !== '/') {
      // Ensure path starts with a leading slash (in IE11 it does not).
      path = '/' + path;
    }
    return path;
  }
} //rnAuthInterceptor
